import React from 'react';

interface RaceData {
  startDate?: string;
  openRegistrationDate?: string | null;
  closeRegistrationDate?: string | null;
  status?: string;
}

interface HeroSectionProps {
  t: any;
  timer: string;
  handleRegisterClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  race?: RaceData | null;
}

const HeroSection = ({ t, timer, handleRegisterClick, race }: HeroSectionProps) => {
  const now = new Date();
  const startDate = race?.startDate ? new Date(race.startDate) : null;
  const isRaceOver = startDate ? now > startDate : false;
  const isRegistrationOpen = race?.openRegistrationDate && race?.closeRegistrationDate
    ? now >= new Date(race.openRegistrationDate) && now <= new Date(race.closeRegistrationDate)
    : false;

  return (
    <section className="hero-section">
      <div className="hero-bg">
        <img src="./assets/hero-image.png" alt="Hero Banner" className="hero-img" />
      </div>
      <div className="hero-content" style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
        <div className="hero-logo">
          <img src="./assets/logo.png" alt="Logo" />
        </div>
        <div className="hero-slogan" style={{ marginBottom: 16 }}>{t.slogan}</div>
        <div className="countdown-timer over-hero" style={{ marginBottom: 16 }}>
          {timer}
        </div>
        <div className="hero-buttons" style={{ marginBottom: 48 }}>
          {isRaceOver ? (
            <a href="https://www.tagtiming.mk/drimrun/results2025.htm" className="btn primary">{t.results}</a>
          ) : isRegistrationOpen ? (
            <a href="#register" className="btn primary" onClick={handleRegisterClick}>{t.register}</a>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
